import { PageLayout } from 'src/shared/layout/PageLayout'
import { Outlet, useLocation } from 'react-router'
import { useEffect, useState } from 'react'
import { NestedRoute, Route, SecondLevelRoute } from 'src/routing/routing'
import { Location } from 'history'
import { ROUTES } from 'src/routing/routes'
import { SecondLevelNavigation, SecondLevelNavigationContainer } from 'src/routing/SecondLevelNavigation'

const resolveActiveRoute = (location: Location): SecondLevelRoute => {
  const nested = ROUTES.CommitteesConfigurationIndex!.nested! as unknown as NestedRoute
  const activeRoute = Object.keys(nested).find(
    (key) =>
      location.pathname.endsWith(nested[key].path) ||
      (ROUTES.CommitteesConfigurationIndex.params({}) === location.pathname && nested[key].primary),
  ) as string
  return nested[activeRoute] as SecondLevelRoute
}

export const CommitteeConfigurationIndexPage = () => {
  const location = useLocation()
  const [activeRoute, setActiveRoute] = useState<SecondLevelRoute>(() => {
    return resolveActiveRoute(location)
  })

  useEffect(() => {
    const newActiveRoute = resolveActiveRoute(location)
    setActiveRoute(newActiveRoute)
  }, [location])

  const showNavigation = activeRoute && !activeRoute.hideNavigation

  return (
    <SecondLevelNavigationContainer $showNavigation={showNavigation}>
      {showNavigation && (
        <PageLayout>
          <SecondLevelNavigation
            activeRoute={activeRoute}
            route={ROUTES.CommitteesConfigurationIndex as unknown as Route}
            baseUrl={ROUTES.CommitteesConfigurationIndex.params({})}
          />
        </PageLayout>
      )}
      <Outlet />
    </SecondLevelNavigationContainer>
  )
}
